import classNames from 'classnames'
import styles from './ExpandableSelect.module.scss'
import type { ExpandableSelectProps } from './types'
import { Icon } from '@boltenergy-be/design-system'

const ExpandableSelect = ({
  children,
  input,
  secondLine,
  isSelected,
  title,
  isOpen,
  handleOpen,
  handleClose,
  disabled
}: ExpandableSelectProps) => {
  return (
    <li className={classNames(styles.card, { [styles.selected]: isSelected, [styles.disabled]: disabled })}>
      <label className={styles.label}>
        <input
          disabled={disabled}
          type="radio"
          {...input}
          onClick={(e) => {
            input?.onClick?.(e)
            handleOpen()
          }}
        />
        <strong>{title}</strong>
        {!!secondLine && <div className={styles['second-line']}>{secondLine}</div>}
      </label>
      <button
        type="button"
        className={classNames(styles['dropdown-toggle'], { [styles.open]: isOpen })}
        onClick={isOpen ? handleClose : handleOpen}
      >
        <Icon name="chevronDropdown" />
      </button>
      {isOpen && <div className={styles.children}>{children}</div>}
    </li>
  )
}

export default ExpandableSelect
